export const resolverOverrides = (_mockStore: any) => ({});
